import styled from 'styled-components';

export const CustomHeaderStyle = styled.div`
  align-items: center;
  flex-direction: column;
  display: flex;
  height: 55px;
  border-bottom: 1px solid #dedede;
  justify-content: center;
  background: white;
  max-width: 453px;
  margin: 0 auto;

  @media all and (max-width: 600px) {
    width: 100%;
  }
`;

export const CHImg = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  
`;